import React from 'react';
import IconFacebook  from './assets/icons/facebook.svg';
import IconTwitter from './assets/icons/twitter.svg';
import IconGithub from './assets/icons/github.svg';
import "./App.css";

export default function App() {

    return (
        <div className="card">
            <div className="header">
                <div className="logo">
                    <a href=".">Nexiom</a>
                </div>
                <div className="social">
                    <a href="https://facebook.com/nexiomhq" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <img src={IconFacebook} alt="Nexiom" className="icon" />
                    </a>
                    <a href="https://twitter.com/nexiomhq" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <img src={IconTwitter} alt="Nexiom" className="icon" />
                    </a>
                    <a href="https://github.com/nexiomhq" title="GitHub" target="_blank"
                       rel="noopener noreferrer">
                        <img src={IconGithub} alt="Nexiom" className="icon" />

                    </a>
                </div>
            </div>
            <div className="content">
                <div className="title-holder">
                    <h1>Get ready for the change.</h1>
                    <p>Website coming soon. Please check back to know more. Shoot us an email if you're curious.</p>
                </div>
                <a href="mailto:hello@nexiom.app">
                    <div className="cta">Drop us an email</div>
                </a>
            </div>
            <div className="footer">
                <span>made with ♥ by <a className="underlined" href="https://nexiom.app" target="_blank"
                                 rel="noopener noreferrer">Nexiom</a></span>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/App.js